import React from 'react';

const Dots = () => {
  return (
    <div className="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full">
      <div className="relative h-full max-w-screen-xl mx-auto">
        <svg
          className="absolute transform left-full -translate-y-3/6 -translate-x-1/12 md:-translate-y-3/6 lg:-translate-x-1/12"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="5d0dd344-b041-4d26-bec4-8d33ea57ec9b"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                className="text-indigo-600"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)"
          />
        </svg>
      </div>
    </div>
  );
};

export default Dots;
